import { EChartTitleOption } from 'echarts'
import { getTextStyles } from './styles'
import { getItemStyle } from '../functions'
import { getFormatter } from './'

export const getTitleSettings = (displayOptions: MapDisplaySettingsOptions, kind: string): EChartTitleOption => ({
    text: displayOptions.moduleTitle !== '' ? displayOptions.moduleTitle : `${kind} Map`,
    textStyle: getTextStyles(displayOptions.titleColor, displayOptions.titleFontSize, displayOptions.titleBold, displayOptions.titleItalic),
    subtext: displayOptions.moduleSubTitle,
    subtextStyle: getTextStyles(displayOptions.subTitleColor, displayOptions.subTitleFontSize, displayOptions.subTitleBold, displayOptions.subTitleItalic),
    sublink: '',
    left: 'center',
})

export const getSeriesSettings = (displayOptions: MapDisplaySettingsOptions, kind: MapType, boundingCoords?: MapCoordinateBounds) => ({
    aspectScale: 1,
    type: 'map',
    roam: false,
    map: kind,
    itemStyle: getItemStyle(displayOptions.borderColor),
    top: "20",
    boundingCoords,
})

export const getTooltipSettings = (aggregateDollarsLabel: string, showAggregateTooltip: boolean, uniqueCountLabel: string, showUniqueCountTooltip: boolean) => ({
    trigger: 'item',
    showDelay: 0,
    transitionDuration: 0.2,
    formatter: getFormatter.bind(null, aggregateDollarsLabel, showAggregateTooltip, uniqueCountLabel, showUniqueCountTooltip),
})
